import styled from 'styled-components';

export default styled.div`
  position: relative;
  touch-action: none;
  pointer-events:none;
  background: url(${ props => props.background});
  width: ${ props => props.width ? props.width+'px' : '100%'};
  height: ${ props => props.height ? props.height+'px' : '100%'};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  image-rendering: -webkit-optimize-contrast;
`;
